import { pushTo } from '@app/core/routing';
import { CompositionSocialUploadItemDto } from '@app/modules/compose/composition.types';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { useUploadCardActions } from '@app/modules/social-export/publish';
import { webAppGetCompositionsDetailSocialUploadsQueryKey } from '@mi-front/api-v2';
import { useQueryClient } from '@tanstack/react-query';

export interface UseComposeSocialExportUploadItemCardActionsParams {
  compositionId: string;
  upload: CompositionSocialUploadItemDto;
}

/**
 * Composition upload card actions: wires shared menu/dialog logic to composition queries and routes.
 */
export function useComposeSocialExportUploadItemCardActions({
  compositionId,
  upload,
}: UseComposeSocialExportUploadItemCardActionsParams) {
  const queryClient = useQueryClient();
  const platform = socialPlatforms.get(upload.platform);

  return useUploadCardActions({
    upload,
    onRetry: () => {
      pushTo(composeRouteGenerator.upload(compositionId, platform.id));
    },
    onDeleteSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: webAppGetCompositionsDetailSocialUploadsQueryKey(compositionId),
      });
    },
    onPromoteSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: webAppGetCompositionsDetailSocialUploadsQueryKey(compositionId),
      });
    },
  });
}
